import type { ErpIntegration } from '@client/api';

import type { ErpSystem } from './mock/portfolio-economy.mock';

/**
 * The API sends the backend enum member (`Tripletex`); `ErpSystem` values are camelCase because
 * they double as i18n keys (`erpSystem.tripletex`). The two casings have to be bridged explicitly.
 *
 * Typed as a total `Record<ErpIntegration, …>` on purpose: `toLowerCase()` happens to work for
 * `Tripletex` and breaks silently on `PowerOffice` or `VismaBusiness`. This way widening the backend
 * enum is a **compile error** here rather than an empty dropdown in production.
 *
 * On the two nullable fields of `EconomySettingsOverviewResponse`, whose meaning the generated types do not
 * carry (the DTO's XML comments did not reach swagger):
 * - `erpSystem` is `undefined`/`null` when no ERP system is registered for the corporation.
 * - `erpConfigured` is `false` when we established that no ERP is wired up, and `null` when the
 *   Admin API did not answer, so we could not establish it either way. The two are **not** the
 *   same: `false` is a fact, `null` is an unknown, and only `false` should render "Ikke
 *   konfigurert".
 */
export const ERP_SYSTEM_BY_API_VALUE: Record<ErpIntegration, ErpSystem> = {
  Tripletex: 'tripletex',
};
